import { configs } from "../../configs";
import { INotificacao, IRetornoObterParametrosDaURL, ISolicitacaoSenha, ITokenDecodeProps, TSeverityNotificacao, TTipoDaMensagem } from "../../interfaces";
import { ApiException } from "../../services";
import { Redirecionar } from "../Redirecionar";
import { jwtDecode } from 'jwt-decode';

export const obterTempoDeLeitura = (textoALer: string): number => (((textoALer.split(" ").length * 60) / 90) * 1000);

export const esperar = async (ms: number): Promise<void> => new Promise((res) => window.setTimeout(() => res(), ms));

export const animarSaidaModal = async (ref: React.RefObject<any>) => {

    document.body.style.pointerEvents = 'none';

    ref.current?.classList.replace('zoomIn', 'zoomOut');

    await esperar(500);

    ref.current?.classList.replace('zoomOut', 'zoomIn');

    document.body.style.pointerEvents = 'auto';

}

export const criarAlerta = (severityNotificacao: TSeverityNotificacao, mensagem: string, setNotificacao: React.Dispatch<React.SetStateAction<INotificacao>>) => {

    const tempoEmTela = obterTempoDeLeitura(mensagem) + 500;

    let severity = severityNotificacao;

    if (mensagem.includes("(#401)")) severity = "warning";

    setNotificacao({ severity, mensagem, tempoEmTela });

    return new Promise((res) => {

        setTimeout(async () => {

            setNotificacao({ severity: '', mensagem: '', tempoEmTela });

            res('ok');

        }, tempoEmTela);

    });

}

export const handleValidarToken = (token: string) => {
    try {
        // SE TIVER OK SÓ RETORNA, SE NÃO REDIRECIOA PARA LOGIN
        return jwtDecode<ITokenDecodeProps>(token);
    } 
    catch {
        Redirecionar.paraLogin();
    }
}

export const obterParametrosDaURL = (): IRetornoObterParametrosDaURL => {

    const parametrosDaURL: IRetornoObterParametrosDaURL = {
        token: '',
        sequencial: undefined,
        tipoDaMensagem: undefined
    }

    const parametrosRecebidos: string[] = window.location.href.split(`${configs.BASENAME}?`)[1]?.split("&");

    parametrosRecebidos?.forEach((parametro => {

        const [chave, valor] = parametro.split("=");

        handleValidarToken(valor);

        if (chave === 'token') {

            parametrosDaURL.token = valor;

        } else if (chave === 'sequencial') {

            parametrosDaURL.sequencial = Number(valor);

        } else if (chave === 'tipoDaMensagem') {

            parametrosDaURL.tipoDaMensagem = valor.toLowerCase() as TTipoDaMensagem;

        }

    }));

    return parametrosDaURL;

}

export const limparIntervalosExistentes = () => {

    let id = window.setInterval(() => { }, 0);

    while (id--) { window.clearInterval(id) };

}

export const obterIdPedidoSolicitacaoPendente = (mensagemSolicitacao: string): string => {

    if (!mensagemSolicitacao) return ''

    const indiceInicioIdPedido = mensagemSolicitacao.toLowerCase().indexOf('id:') + 3;

    const indiceFimIdPedido = mensagemSolicitacao.toLowerCase().indexOf('fornecedor:');

    const idPedido = mensagemSolicitacao.substring(indiceInicioIdPedido, indiceFimIdPedido).trim();

    return idPedido;

}

export const tratarMensagemDeErroNaBuscaDeDados = (erro: any, setNotificacao: React.Dispatch<React.SetStateAction<INotificacao>>) => {
    if (!(erro instanceof ApiException)) return;

    if (erro.status === 400) return criarAlerta('warning', erro.message, setNotificacao);

    if (erro.status === 401) return criarAlerta('warning', erro.message, setNotificacao);

    if (erro.status === 404) return criarAlerta('warning', erro.message, setNotificacao);

    if (erro.status === 409) return criarAlerta('warning', erro.message, setNotificacao);

    if (erro.status === 500) return criarAlerta('error', erro.message, setNotificacao);

    if (erro.status === 0) return criarAlerta('error', erro.message, setNotificacao);
}

export const lancarAlertaPadraoParaListaVazia = (listaSolicitacaoSenha: ISolicitacaoSenha[], notificacao: INotificacao, setNotificacao: React.Dispatch<React.SetStateAction<INotificacao>>) => {

    if (listaSolicitacaoSenha.length === 0 && notificacao.severity !== "success")
        return criarAlerta("warning", "Não existe solicitações de senha pendentes para o usuário.", setNotificacao);

}